import React from 'react';
import { Label } from '../ui/label';
import { PRIORITY_OPTIONS, TYPE_GROUPS, TYPE_COLOR_MAP, renderTypeIcon } from './feedbackConstants';

/**
 * Renders the type-of-feedback + priority selector grids.
 */
export default function TypePrioritySelectors({ form, setForm }) {
  return (
    <>
      {TYPE_GROUPS.map((group, idx) => (
        <div
          key={`type-row-${idx}`}
          className={`grid grid-cols-3 gap-2 ${idx === 0 ? 'mb-2' : ''}`}
        >
          {group.map((type) => (
            <button
              key={type}
              onClick={() => setForm({ ...form, type })}
              className={`flex flex-col items-center justify-center gap-1 py-2 px-2 rounded-lg border transition-all ${
                form.type === type
                  ? TYPE_COLOR_MAP[type]
                  : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
              }`}
            >
              {renderTypeIcon(type)}
              <span className="text-xs capitalize">{type}</span>
            </button>
          ))}
        </div>
      ))}

      <div>
        <Label>Priority</Label>
        <div className="grid grid-cols-4 gap-2 mt-1">
          {PRIORITY_OPTIONS.map((opt) => {
            const IconComp = opt.icon;
            return (
              <button
                key={opt.value}
                onClick={() => setForm({ ...form, priority: opt.value })}
                className={`flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-lg border transition-all text-center ${
                  form.priority === opt.value
                    ? opt.color
                    : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
                }`}
                title={opt.description}
              >
                <IconComp className="h-4 w-4" />
                <span className="text-xs">{opt.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
